/**
 * Un relevé GPS retenu pour la position actuelle et le tracé.
 *
 * L'historique du serveur garde volontairement les relevés écartés (saut
 * impossible, qualité nulle): `validation_status` les marque. Un relevé sans
 * ce champ (flux temps réel ancien) reste retenu; un relevé marqué autre
 * chose que « valid » ne l'est pas, sans quoi un saut écarté devenait la
 * position actuelle du camion.
 */
export const pointGpsRetenu = (point) =>
  Boolean(point) &&
  point.latitude != null &&
  point.longitude != null &&
  (point.validation_status == null || point.validation_status === 'valid');

/** Les relevés retenus d'un historique, dans le même ordre. */
export const pointsGpsRetenus = (points) =>
  (Array.isArray(points) ? points : []).filter(pointGpsRetenu);
